import {Alert, Divider} from 'antd';
import React from 'react';
import {Link} from 'react-router-dom';
import {ClientData, QuestionnaireRequestParams, SignupRequestParams} from '../../../../types/src';
import {LoginForm, RegisterForm} from '../';
import {brandConfig, STRINGS} from '../../utils';
import {GoogleSignIn} from './GoogleSignIn';

import './signInForm.scss';

interface SignInFormProps {
  client: ClientData;
  login: (email: string, password: string) => Promise<any>;
  signup: (params: SignupRequestParams) => Promise<boolean>;
  onboardQuestionnaire: (params: QuestionnaireRequestParams) => Promise<void>;
  onboardQuestionnaireSkip: () => Promise<void>;
  isSignup: boolean;
  analyticsService: any;
  clearStatus: any;
  googleSignIn?: (requestData: any) => Promise<any>;
}

export const SignInForm = ({
  client,
  login,
  signup,
  onboardQuestionnaire,
  onboardQuestionnaireSkip,
  isSignup,
  analyticsService,
  clearStatus,
  googleSignIn,
}: SignInFormProps) => {
  return (
    <div className="signinForm">
      {!isSignup ? (
        <div>
          <div className="signInTitle">Log In</div>
          {brandConfig.brand !== 'gx' ? 
            <div className="signInSubtitle">
              Not Registered?{' '}
              <Link style={{padding: 0}} to="/signup" onClick={clearStatus}>
                Sign up
              </Link>
            </div>
          : null}
          <LoginForm client={client} login={login} clearStatus={clearStatus} />
          <Divider>or</Divider>
          <GoogleSignIn googleSignIn={googleSignIn} analyticsService={analyticsService} />
        </div>
      ) : (
        <div>
          <div className="signInTitle">Sign Up</div>
          <div className="signInSubtitle">
            Already have an account?{' '}
            <Link style={{padding: 0}} to="/login" onClick={clearStatus}>
              Log in
            </Link>
          </div>
          <RegisterForm
            client={client}
            signup={signup}
            onboardQuestionnaire={onboardQuestionnaire}
            onboardQuestionnaireSkip={onboardQuestionnaireSkip}
            analyticsService={analyticsService}
          />
          <Divider>or</Divider>
          <GoogleSignIn googleSignIn={googleSignIn} analyticsService={analyticsService} signText="signup_with" />
        </div>
      )}
      {client.unauthorizedError && (
        <Alert
          message=""
          description={STRINGS.warning.login_incognito_cookie}
          type="error"
          style={{marginBottom: '10px'}}
        />
      )}
    </div>
  );
};
